
















import { fetchMarketplaceLocations } from '@/services/marketplace-orders'

export default {
  name: 'AddressTypeAhead',
  props: {
    title: { type: String, default: '' },
    optionLabel: { type: String, default: null },
    optionKey: { type: String, default: null },
    placeholder: { type: String, default: null },
    location: { type: Array, default: () => [] }
  },
  data() {
    return {
      options: []
    }
  },
  watch: {
    location(value) {
      this.options = value
    }
  },
  methods: {
    async onFetchFilterOptions(query) {
      const currentLanguage = this.$i18n.locale

      const queryBuilder = {
        location: query,
        language: currentLanguage
      }
      this.options = await fetchMarketplaceLocations(queryBuilder)
    },
    onClearFilterOptions() {
      this.options = []
      this.$emit('input', null)
    }
  }
}
